import { call, takeLatest } from "redux-saga/effects";
import * as productApis from "../apis/productApis"
import { CATEGORY_DROPDOWN, CREATE_PRODUCT, DELETE_PRODUCT, EDIT_PRODUCT, LIST_PRODUCT, UPLOAD_PRODUCT_IMAGE, VIEW_PRODUCT } from "../actions/types";


export function* createProductWorker(action) {
    try {
        const res = yield call(productApis.createProductApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editProductWorker(action) {
    try {
        const res = yield call(productApis.editProductApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteProductWorker(action) {
    try {
        const res = yield call(productApis.deleteProductApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listProductWorker(action) {
    try {
        const res = yield call(productApis.listProductApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewProductWorker(action) {
    try {
        const res = yield call(productApis.viewProductApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadImageWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(productApis.uploadImageApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* categoryDropdownWorker(action) {
    try {
        const res = yield call(productApis.categoryDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher Func */
export function* createProductWatcher() {
    yield takeLatest(CREATE_PRODUCT, createProductWorker);
}
export function* editProductWatcher() {
    yield takeLatest(EDIT_PRODUCT, editProductWorker);
}
export function* deleteProductWatcher() {
    yield takeLatest(DELETE_PRODUCT, deleteProductWorker);
}
export function* listProductWatcher() {
    yield takeLatest(LIST_PRODUCT, listProductWorker);
}
export function* viewProductWatcher() {
    yield takeLatest(VIEW_PRODUCT, viewProductWorker);
}
export function* uploadImageWatcher() {
    yield takeLatest(UPLOAD_PRODUCT_IMAGE, uploadImageWorker);
}
export function* categoryDropdownWatcher() {
    yield takeLatest(CATEGORY_DROPDOWN, categoryDropdownWorker);
}